module.exports = __webpack_public_path__ + "img/chamada-vagas.c903e5de.png";